import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleText',
})
export class RoleTextPipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return '';
        }

        switch (value) {
            case 'BoardMember':
                return 'Board Member Access';
            case 'BoardAssistant':
                return 'Board Assistant Access';
            case 'Superintendent':
                return 'Superintendent Access';
            case 'DeputySuperintendent':
                return 'Deputy Superintendent Access';
            case 'Cabinet':
                return 'Cabinet Access';
            case 'Facilitator':
                return 'Facilitator Access';
            case 'Responder':
                return 'Responder Access';
            case 'Developer':
                return 'Developer Access';
            default:
                return '';
        }
    }
}
